import OnboardingScreen from './index';

const routes = [
  {
    path: '/onboarding-client',
    component: OnboardingScreen,
  },
];

export default routes;
